import { computed, Component, inject, input } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { TeamMemberStatus } from '@core/tellent-types';
import { BadgeComponent } from '@core/user-interface-legacy';

import { getMemberStatusConfig, type MemberStatusConfig } from '../edit-member-status.config';

@Component({
  selector: 'tlc-edit-member-status',
  imports: [BadgeComponent],
  templateUrl: './edit-member-status.component.html',
})
export class EditMemberStatusComponent {
  private readonly i18n = inject(I18nService);

  public currentStatus = input.required<TeamMemberStatus>();
  public hasWorkEmail = input.required<boolean>();
  public hasPersonalEmail = input.required<boolean>();
  public loginMethod = input.required<'email' | 'username'>();

  protected currentConfig = computed<Partial<MemberStatusConfig>>(() =>
    getMemberStatusConfig(
      this.currentStatus(),
      {
        hasWorkEmail: this.hasWorkEmail(),
        hasPersonalEmail: this.hasPersonalEmail(),
        loginMethod: this.loginMethod(),
      },
      this.i18n,
    ),
  );
}
